// extracted by mini-css-extract-plugin
export var selected = "Templates-module--selected--W8YuK";
export var template = "Templates-module--template--3iJCP";